import { createSlice } from '@reduxjs/toolkit';

import { IAuth } from '@/shared/types/auth';

import { TUser } from '../types/User';

export interface IStateUserSlice {
  data: TUser;
  auth: IAuth;
}

const initialState = {} as IStateUserSlice;

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    /**
     * Обновление данных пользователя
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Новые данные
     */
    update: (state, { payload }: { payload: Partial<IStateUserSlice> }) => ({
      ...state,
      ...payload
    }),
    /** Удаление данных пользователя */
    reset: () => initialState
  }
});

export const { update: updateUser, reset: resetUser } = userSlice.actions;
export const { reducer: userReducer } = userSlice;
